import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap, LayersControl } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// --- Ícones Personalizados por Fonte de Dados ---

// 1. Ícone de Casinha (Coordenadas Extras)
const houseIcon = new L.Icon({
    iconUrl: process.env.PUBLIC_URL + '/house.png', // Certifique-se que o nome é house.png
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
    shadowSize: [41, 41]
});

// 2. Ícone Azul (3ª Tranche)
const blueIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

// 3. Ícone Verde (Convencional)
const greenIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

// Função para decidir qual ícone usar
const getIcon = (fonte) => {
    if (fonte === 'Coordenadas Extras') return houseIcon;
    if (fonte === 'Convencional') return greenIcon;
    return blueIcon; // Padrão para 3ª Tranche e outros
};

// Componente para controle de zoom e centralização
function MapController({ localities, routePoints }) {
    const map = useMap();

    useEffect(() => {
        const validLocalities = localities.filter(loc => loc && typeof loc.latitude === 'number' && typeof loc.longitude === 'number');

        if (routePoints?.pontoA && routePoints?.pontoB) {
            const bounds = L.latLngBounds([
                [routePoints.pontoA.latitude, routePoints.pontoA.longitude],
                [routePoints.pontoB.latitude, routePoints.pontoB.longitude]
            ]);
            map.fitBounds(bounds, { padding: [50, 50] }); 
        } else if (validLocalities.length > 0) {
            const bounds = L.latLngBounds(validLocalities.map(loc => [loc.latitude, loc.longitude]));
            if (bounds.isValid()) {
                map.fitBounds(bounds, { padding: [50, 50] });
            }
        } else {
            map.setView([-4.5, -63], 5);
        }
    }, [localities, routePoints, map]); 

    return null;
}

const PopupContent = ({ localidade }) => (
    <>
        <b>ID:</b> {localidade.id}<br/>
        <b>Comunidade:</b> {localidade.nome_comunidade}<br/>
        <b>Município:</b> {localidade.municipio}<br/>
        <b>Fonte:</b> {localidade.fonte_dados}<br/>
        <b>Calha:</b> {localidade.calha_rio_nome || 'Não definida'}<br/>
        <b>Domicílios/UCs:</b> {localidade.domicilios || 'N/A'}<br/>
        <b>Total de Ligações:</b> {localidade.total_ligacoes || 'N/A'}
    </>
);

const MapComponent = ({ localidades = [], routePoints = {}, routeResult = null }) => {
    const initialPosition = [-4.5, -63];
    const isRouteMode = routePoints.pontoA && routePoints.pontoB;

    return (
        <MapContainer center={initialPosition} zoom={5} style={{ height: '100%', width: '100%' }}>
            
            <LayersControl position="topright">
                <LayersControl.BaseLayer checked name="Mapa de Rua">
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; OpenStreetMap contributors'
                    />
                </LayersControl.BaseLayer>
                <LayersControl.BaseLayer name="Satélite">
                    <TileLayer
                        url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                        attribution='Tiles &copy; Esri'
                        maxZoom={17}
                    />
                </LayersControl.BaseLayer>
            </LayersControl>

            <MapController localities={localidades} routePoints={routePoints} />

            {isRouteMode ? (
                <>
                    <Marker position={[routePoints.pontoA.latitude, routePoints.pontoA.longitude]} icon={getIcon(routePoints.pontoA.fonte_dados)}>
                        <Popup autoOpen><PopupContent localidade={routePoints.pontoA} /></Popup>
                    </Marker>
                    <Marker position={[routePoints.pontoB.latitude, routePoints.pontoB.longitude]} icon={getIcon(routePoints.pontoB.fonte_dados)}>
                        <Popup autoOpen><PopupContent localidade={routePoints.pontoB} /></Popup>
                    </Marker>
                    <Polyline positions={[[routePoints.pontoA.latitude, routePoints.pontoA.longitude], [routePoints.pontoB.latitude, routePoints.pontoB.longitude]]} color="red" />
                </>
            ) : (
                localidades
                    .filter(loc => loc && typeof loc.latitude === 'number' && typeof loc.longitude === 'number')
                    .map(loc => (
                        <Marker 
                            key={loc.id} 
                            position={[loc.latitude, loc.longitude]}
                            icon={getIcon(loc.fonte_dados)}
                        >
                            <Popup><PopupContent localidade={loc} /></Popup>
                        </Marker>
                    ))
            )}
        </MapContainer>
    );
};

export default MapComponent;